export default __webpack_public_path__ + "static/media/29.0a32b1d7.png";